import { render, staticRenderFns } from "./notificationBox.vue?vue&type=template&id=532beae0&scoped=true"
import script from "./notificationBox.vue?vue&type=script&lang=js"
export * from "./notificationBox.vue?vue&type=script&lang=js"
import style0 from "./notificationBox.vue?vue&type=style&index=0&id=532beae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.95.0__lodash@4.17.21_v_l73aw7oujcok7tndgraouq6t3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532beae0",
  null
  
)

export default component.exports